import { render } from "./PreXuanti.vue?vue&type=template&id=3c040b3e&scoped=true"
import script from "./PreXuanti.vue?vue&type=script&lang=js"
export * from "./PreXuanti.vue?vue&type=script&lang=js"

import "./PreXuanti.vue?vue&type=style&index=0&id=3c040b3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c040b3e"]])

export default __exports__